export const TASK_TYPE = 'taskType';

export const MY_TASKS = 'tasks';
export const GROUP_TASKS = 'group_tasks';

export const CREATE_TIME = 'createTime';
export const DUE_DATE = 'dueDate';

export const ASC_ORDER = 'asc';
export const DESC_ORDER = 'desc';

export const ALL_WORKFLOWS = "All Workflows";
export const WORKFLOW_id = "all_workflows";

export const CURRENT_TASK_PAGE = 'CURRENT_TASK_PAGE';

export const CURRENT_TASK_FILTER_TYPE = 'CURRENT_TASK_FILTER_TYPE';

export const FILTER_BY_VALUE = 'FILTER_BY_VALUE';

export const CURRENT_TASK_ORDER_SORT = 'CURRENT_TASK_ORDER_SORT';

export const TASK_FILTER_BY_SORT = 'TASK_FILTER_BY_SORT'

export const TASK_FILTER_BY_ORDER = 'TASK_FILTER_BY_ORDER'

export const DEFAULT_FILTERS_DATA= {
    taskType: MY_TASKS,
    filterField: ""
};

export const MAX_PAGE_SIZE = 50

export const MIN_PAGE_SIZE = 5

export const CURRENT_TASK_SIZE = "CURRENT_TASK_SIZE"